import type { FaireProductEntity } from "../../entity_types/product";

export const p_5czf6li828: FaireProductEntity = {
  token: "p_5czf6li828",
  type: "product",
  name: "White Tea & Violet: 2-in-1 Soy Lotion Candle",
  brandToken: "b_a0c8ovfuxn",
  brandName: "Creative Energy Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/60ec35c9ef43a1aa7de8fdc142b6406de2b2ce1d415057140d1e7ffb43d70dea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c9dab44a6d87d97c2d668f4438d814fdce15872503b19a0c71e81fb6915f78b7.jpeg",
    "https://cdn.faire.com/fastly/17e60daafb83db1881fbe52fd9aa372dd936fce4e169cd24680d558504eb0cc0.jpeg",
    "https://cdn.faire.com/fastly/3c8ef6e84170bde70f558a3e67fc5e6fb0dd903b54b8fd59b3758091dfa420d6.jpeg",
    "https://cdn.faire.com/fastly/29984443c983d355da61d4a5fecdd24a9508082b186d3a4c52f84b8bee269734.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/56b50ef0af63f97b20a8305bbab0cc44c96063fcb08b2b9bf5e1beda9549a8d1/1560890482.jpg",
    "https://cdn.faire.com/fastly/926b74c895cf8f92be87e63ffddb966ed0d3ae1ec0246aa67d0a62f79ee339fa.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/a1c81b4f22e201ef5f855cddc117d22ed45d957d6465c734ca7a3e6a021c3ac5/1560890478.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/1407b1b72961f76c7c9e611db3fec977e13165cec361218744b853e363179d88/1560890478.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/51034fd0386f5ca13709c3352d6edbef8341be834d423324037efa284b72913a/1560890478.jpg",
    "https://cdn.faire.com/fastly/2172b3db7b275a89261d1799c2676d3c36d69a91f2f530bd10ecf482268846b2.jpeg",
    "https://cdn.faire.com/fastly/200c47d15853bb261e28a5ef6920e81a783a3d2c5408cc92d4d5536949a87529.jpeg",
    "https://cdn.faire.com/fastly/f39d422c97e12d35e82bd2ce2d383e074eaf06bda25908f0a9cc9b63156402f5.jpeg",
    "https://cdn.faire.com/fastly/69c2559693556a819ff13236046205c5baba6d09e9586ab6c6aa099b5f8c5aed.jpeg",
    "https://cdn.faire.com/fastly/afe595428c9a70f9f45a1471730d18eb5dd5d9420f4745118f86506fcf07b7ba.jpeg",
    "https://cdn.faire.com/fastly/84fbc45bf7b34ac74f991e54e8e209da824cb3cb74c445fbdc17741473f933e7.jpeg",
  ],
  priceDollars: 18,
  description:
    "Smells like an elegant tea party. The familiar scent of white tea is made new by adding violet, cedarwood, jasmine, and vanilla.\n\nInfused with essential oils of cedarwood, vanilla, violet, jasmine, lemon and nutmeg.\n\n𝐁𝐮𝐫𝐧 𝐓𝐢𝐦𝐞𝐬:\n• 10 oz: 55 hrs\n• 6 oz: 35 hrs\n• 3.5 oz Travel Tin: 23 hrs\n\n**Only one tester per scent ordered can be purchased with each order**",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:59.218Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
